import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import settings from "settings";
import RegisterForm from "vino/components/Register/RegisterForm";

const SignupPage = () => {
	return (
		<div className="Login3-leftSection flex flex-col w-full items-center justify-center mb-32">
			<div className="flex flex-col items-center justify-center w-full px-36 max-w-320 mb-32">
				<motion.div
					initial={{ opacity: 0 }}
					animate={{ opacity: 1, transition: { delay: 0.2 } }}
				>
					<div className="flex items-center my-16">
						<div>
							<Typography
								className="text-24 font-semibold logo-text"
								color="inherit"
							>
								Create your Corksy account
							</Typography>
						</div>
					</div>
				</motion.div>

				<RegisterForm redirectUrl={settings.urls.checkout} />
			</div>

			<Divider className="w-full" />

			<div className="flex flex-col items-center justify-center mt-32">
				<span className="font-normal mb-5">Already have an account?</span>
				<Button
					variant="contained"
					component={Link}
					to="/account/login"
					color="secondary"
					className="font-normal"
				>
					Login
				</Button>
			</div>
		</div>
	);
};

export default SignupPage;
